import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { EndPoints, PaymentEndpoints } from '../../configs/api.configs';
import { HttpService } from '../helper/http.service';
import { UserManagerService } from '../userManager/user-manager.service';
import { BehaviorSubject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { PaymentProvider } from 'src/models/lonaci-models/payment-provider.model';
import { ThemeService } from '../theme/theme.service';
import { environment } from 'src/environments/environment';
import { PmuService } from '../data/pmu.service';

@Injectable({
  providedIn: 'root'
})
export class MyAccountService {

  public paymentProviders: Record<string | number, PaymentProvider[]> = {"1": [], "2": []};
  private _activeAccountstab = 1;
  private _usersbanks: Array<any> = [];
  loadingProviders: boolean = false;
  public get usersbanks(): Array<any> {
    return this._usersbanks;
  }
  public set usersbanks(value: Array<any>) {
    this._usersbanks = value;
  }
  private _tabs: Array<any> = [];
  public get tabs(): Array<any> {
    return this._tabs;
  }
  public set tabs(value: Array<any>) {
    this._tabs = value;
  }

  public get activeAccountstab(): number {
    return this._activeAccountstab;
  }
  public set activeAccountstab(value: number) {
    this._activeAccountstab = value;
  }
  paymentProviders$ = new BehaviorSubject<Record<string | number, PaymentProvider[]>>({"1": [], "2": []});

  constructor(
    private requestHandler: HttpService,
     private configService: ConfigService,
     private userService: UserManagerService,
     private themeService: ThemeService,
     private pmuService: PmuService) { }

  getProviders(id: any): Promise<any> {
    if(!this.themeService.useGateway){
      if(!this.paymentProviders || !(this.paymentProviders['1'].length > 0 && this.paymentProviders['2'].length > 0))
      {
        // Reunions/AC data (which also carries payment operators in AC[0]) is already
        // fetched once by PmuService.getActiveGames() — reuse that instead of firing
        // a second, identical get_active_games request.
        this.pmuService.getOperatorsFromAC().pipe(
          filter((operators): operators is any[] => !!operators?.length),
          take(1)
        ).subscribe((operators) => {
          this.paymentProviders['1'] = operators;
          this.paymentProviders['2'] = operators;
        });
      }
      return new Promise((resolve, reject)=>{
        resolve("done");
      });
    }

    else{
      const api = id === 1 ? 'cashInProviders' : 'cashOutProviders';
      this.loadingProviders = true;

      return this.requestHandler.get_request(environment.API.userService, EndPoints['providers'] + api, {}, true).then((response: { data: any[]; }) => {
        const providers: any[] = [];
        response.data.forEach((element: { hasOwnProperty: (arg0: string) => any; sub_providers: any[]; code: any; pdv: any; min: number; max: number; }) => {
          if (element.hasOwnProperty('sub_providers') && element.sub_providers.length > 0) {
            element.sub_providers.forEach((subProv: { pdv: any; min: number; max: number; }) => {
              subProv.pdv = element.code;
              subProv.min = Number(subProv.min);
              subProv.max = Number(subProv.max);
              providers.push(subProv);
            });
          } else {
            element.pdv = element.code;
            element.min = Number(element.min);
            element.max = Number(element.max);
            providers.push(element);
          }

        });
        this.paymentProviders[id] = providers;
        this.paymentProviders$.next(this.paymentProviders);
        // console.log((id === 1 ? 'cashInProviders' : 'cashOutProviders') + " (" + id + "): ", providers);
        // console.log("all providers", this.paymentProviders);

      }).finally(() => {
        this.loadingProviders = false;
      });
    }

  }

  setProvPhoneNumbers(providers:Array<any>){
    providers.forEach(subProv=>{
      if(subProv.accnt && subProv.accnt.startsWith(this.configService.country_code)){
        subProv.accnt = subProv.accnt.split(this.configService.country_code)[1]
      }
     })

     return providers;

  }
  triggerPMUGTransactions(arg0: any, accountParams: any) {
    accountParams.lg_Channel_ID=7
    accountParams.lang=this.userService.userData.lang
    return this.requestHandler.get_request(environment.API.userService ,  EndPoints[arg0], accountParams);

  }
  confirmRetrait(arg0: any, accountParams: any) {
    return this.requestHandler.authPost(environment.API.userService + '/', EndPoints[arg0], accountParams);
  }
  confirmRecharge(arg0: any, accountParams: any) {
    return this.requestHandler.authPost(environment.API.userService + '/', EndPoints[arg0], accountParams);
  }
  getUserBanks() {
    this.requestHandler.get_request(environment.API.userService , '/account/' + this.userService.userData.customer_ID ? this.userService.userData.customer_ID : this.userService.userData.lg_AGENT_ID, {}).then((responseData: any[]) => {
      this.usersbanks = responseData;
    });
  }
  validateOTP(accountParams: any) {
    return this.requestHandler.authPost(environment.API.userService + '', EndPoints[accountParams['pdvurl'] + '_CONFIRMATION'], accountParams);
  }

  getOTP(withdrawalAmt: string, Withdrawal = false): Promise<any> {
    var data = {
      sessionId: this.userService.userData.session,
      amount: withdrawalAmt,
      isWithdrawal: Withdrawal
    }
    return new Promise((resolve, reject) => {
      this.requestHandler.authPost(environment.API.sportsGateway, EndPoints['REQUEST_OTP'], data).then((response: any) => {
        resolve(response);
        // if (response.hasOwnProperty("erc") && response.erc == '1') {
        //   resolve(response)
        // }
        // else {
        //   reject(response)
        // }
      })
      .catch((error: any)=>{
        reject(error)
      })
    })
  }

  triggerWithdrawal(arg0: any, accountParams: any) {
    return this.requestHandler.authPost(this.configService.PROXIES.userService , PaymentEndpoints[arg0], accountParams, );
  }
  triggerDeposit(arg0: any, accountParams: any) {
    return this.requestHandler.authPost(this.configService.PROXIES.userService , PaymentEndpoints[arg0], accountParams);
  }
}
